export const convertSchemasResponse = (schemasObject: Record<string, any>) => {
  return Object.keys(schemasObject).map(key => ({
    name: schemasObject[key].name,
    id: schemasObject[key].id,
    json: schemasObject[key].json,
    is_child: schemasObject[key].is_child ?? false,
    is_system: schemasObject[key].is_system ?? false,
    column_grid: schemasObject[key].column_grid ?? [],
    is_active: schemasObject[key].is_active ?? false,
  }));
};
